module.exports = __webpack_public_path__ + "img/btn-code-reg-bg.b0acb5d9.png";